import { DropdownButton, DropdownButtonType } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { FlowOutputStepInfo } from '~src/ts/models/FlowOutputStepInfo';

import { Flows } from '../resources/Flows';
import { FlowOutputSelectorContent, futureOutputRowHeight } from './FlowOutputSelectorContent';

export interface FlowOutputSelectorSelectorProps {
  flowId: string;
  index: number;
}

function getHeightForRows(numRows: number) {
  return numRows * CommonStyles.Sizes.DataGridRowHeight;
}

export function FlowOutputSelector(props: FlowOutputSelectorSelectorProps): JSX.Element {
  const [outputs, setOutputs] = React.useState<ReadonlyArray<FlowOutputStepInfo>>([]);

  React.useEffect(() => {
    Flows.getOutputStepInfos(props.flowId).then(items => {
     setOutputs(items);
    });
  }, [props.flowId]);

  const dropdownId = `$output-dropdown-{props.index}`;
  const dialogStyle = {
    height: getHeightForRows(outputs.length + 1),
    paddingBottom: futureOutputRowHeight,
  };
  return (
    <div>
      <DropdownButton
        label={Messages.linkedTasksOptions()}
        aria-controls={dropdownId}
        aria-haspopup={'dialog'}
        closeOnPopupBlur={true}
        popupContent={
          <div role='dialog' id={dropdownId} style={dialogStyle}>
            {<FlowOutputSelectorContent outputs={outputs} index={props.index}/>}
          </div>
        }
        testId={'FlowOutputSelectorDropdownButton'}
        type={DropdownButtonType.Outline}
      >
        {Messages.selectIndividualOutputs()}
      </DropdownButton>
    </div>
  );
}
